import iconNames from 'theme/icons'
import React from 'react'
import {t} from "helpers/language"

export const skill = {
  key: "IMPORT_CONTACTS",
  group: 'contacts',
  label: t("Import contacts"),
  desc: t("Bring all your existing contacts into your database to start working quickly"),
  location: '/contacts/import',
  steps: [
    {
      title: "Import Contacts",
      titleIcon: iconNames.priceList,
      content: (
          <div>
            Import your contacts by uploading a CSV file.<br/>
            <br/>
            <i>Your CSV import file must:</i>
            <ul>
              <li>Have one row per contact</li>
              <li>Contain at least the forename or surname, and company name of each contact</li>
              <li>Be no larger than 250mb or 100,000 contacts</li>
            </ul>
          </div>
      ),
      actions: [
        {
          label: 'Start Contacts Import',
          primary: true,
          flat: true,
          type: 'next',
        },
      ],
    },
    {
      target: '.fileUploader-container button',
      content: <div>To begin, click on <i>SELECT YOUR CSV IMPORT FILE</i></div>,
    },
    {
      target: '.contactImportStepper-autoDetectButton',
      content: <div>Click on the <i>Auto-Detect Columns</i> button to automatically find all the columns in your csv file.</div>,
      auto: true,
    },
    {
      target: '.contactImportPivotTable-container',
      content: <div>We have detected the columns based on your CSV file and have matched them against your contacts.</div>,
      actions: [
        {
          label: 'Next',
          primary: true,
          flat: true,
          type: 'next',
        },
      ],
    },
    {
      target: '.contactImportStepper-nextButton button',
      content: <div>
        Click on <i>NEXT</i> to continue, if this button is not highlighted there may be some errors in the file.<br/><br/>
        Click on <i>Back</i> to go back a step to review and resolve any issues with the import file.<br/>
      </div>,
      auto: true,
      actions: [
        {
          label: "Back",
          primary: true,
          flat: true,
          type: "skill",
          location: "/contacts/import",
          page: 3,
          skill: "IMPORT_CONTACTS",
        },
      ],
    },
    {
      target: '.contactImportStepper-buttons',
      content: <div>
        Click <i>Import</i> to import your contacts.<br/><br/>
        You can also click <i>Back</i> to return back to the previous step.<br/>
      </div>,
      awaitElement: {awaitTransition: 1000},
    },
  ],
}

export default skill
